@import 'abstract/colors';
@import 'abstract/variables';

@keyframes popup-background {
  from {
    background: rgba(17, 41, 80, 0);
  }
  to {
    background: $popup-background;
  }
}

@keyframes popup-block-open {
  from {
    transform: translate(100%, 0);
  }
  to {
    transform: translate(0, 0);
  }
}

@keyframes popup-block-close {
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(100%, 0);
  }
}
sidebar-right {
  display: none;
  align-items: stretch;
  justify-content: stretch;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: $popup-background;
  z-index: 2147483648;
  animation: popup-background .3s;

  .popup {
    &-backdrop {
      position: relative;
      top: 0;
      left: 0;
      height: 100%;
      flex-grow: 1;
      width: auto;
      background: transparent;
    }
    &-scroll {
      position: relative;
      height: 100%;
      overflow-y: scroll;
      overflow-x: hidden;
      padding-left: 45px;
    }

    &-close {
      position: absolute;
      top: 25px;
      left: 0;
      background: none;
      border: none;
      outline: none;
      padding: 0;
      font-family: Roboto, sans-serif;
      width: 28px;
      height: 28px;
      z-index: 100;
      &:hover {
        cursor: pointer;
      }
      &:before {
        content: "";
        position: absolute;
        top: 9px;
        width: 100%;
        height: 2px;
        left: 0;
        background: #fff;
        transform: rotate(45deg);
      }
      &:after {
        content: "";
        position: absolute;
        top: 9px;
        width: 100%;
        height: 2px;
        left: 0;
        background: #fff;
        transform: rotate(-45deg);
      }
    }
  }
}

sidebar-right.active {
  display: flex;
  .popup-scroll {
    animation: popup-block-open .3s;

    &.hiding {
      animation: popup-block-close .3s;
    }
  }
}
